let feedObserver: IntersectionObserver | null = null;

export function getFeedObserver() {
  if (typeof window === "undefined") return null;

  if (!feedObserver) {
    feedObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const el = entry.target as HTMLElement & {
          __onIntersect?: (entry: IntersectionObserverEntry) => void;
        };

        if (el.__onIntersect) {
          el.__onIntersect(entry);
        }
      }
    });
  }

  return feedObserver;
}
